import React from "react";
import { Formik } from "formik";
import { Col, Form, Button } from "react-bootstrap";
import "./forgot-password.scss";
import { SendResetPasswordEmail } from "../../api";
import Loader from "../loader/loader";

import * as yup from "yup";
import { Link } from "react-router-dom";
const schema = yup.object({
    email: yup
        .string()
        .trim()
        .email("* The Email Must Be A Valid Email Address.")
        .required("* Email-Address is Required"),
});
class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                email: "",
            },
            errors: [],
            disableResetBtn: false,
        };
    }
    componentDidMount() {}
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    handleChangePassword(evt) {
        this.setState({ show_spinner: true });
        const fromData = this.state.formData;
        const postData = {
            email: fromData.email,
        };
        SendResetPasswordEmail(postData).then((res) => {
            this.setState({
                show_spinner: false,
                errorMessage:
                    "If you are a registered user, you will get your reset link in the email.",
                disableResetBtn: true,
            });
        });
    }

    render() {
        const {
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
            disableResetBtn,
        } = this.state;
        return (
            <div>
                <div className="reset-password">
                    <div className="Login-header">
                        <h1>STRATUS</h1>
                    </div>
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleChangePassword(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="send-password-reset-link"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <div className="from-heading">
                                    <h2>STRATUS | Reset Password</h2>
                                </div>
                                <Form.Row className="floating-form">
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3 position-relative"
                                    >
                                        <Form.Control
                                            placeholder="Email"
                                            type="text"
                                            name="email"
                                            value={
                                                values.email ? values.email : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.email && !!errors.email
                                            }
                                            isValid={
                                                is_submitted && !errors.email
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Label className="floating-label">
                                            Email
                                        </Form.Label>

                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.email}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <p className="error-message">{errorMessage}</p>
                                <Button
                                    size="lg"
                                    form="send-password-reset-link"
                                    type="submit"
                                    disabled={disableResetBtn}
                                >
                                    Send Reset Link →
                                </Button>
                                <div className="forgetpassword">
                                    <Link to="/">Go Back</Link>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div className="copy-right">
                        <p>Copyright © PaymentCloud. All Rights Reserved.</p>
                    </div>

                    {show_spinner ? (
                        <div className="spinner">
                            <Loader />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <div className="background-div">
                    <img
                        src="/images/dot_bg.png"
                        alt="background"
                        className="background"
                    />
                </div>
            </div>
        );
    }
}

export default ChangePassword;
